import React from 'react';
import Logo from 'components/layout/logo';
import { Grid, Container, Box, Stack } from 'components/ui';
import { Footer as StyledFooter, FooterTitle, FooterText, FooterDescription } from 'components/styles_components/footer';
import { FormattedMessage } from 'react-intl';
import { TermsLink, PaymentTermsLink, PrivacyPolicyLink } from 'utils/link';
import { DividerContainer } from 'components/styles_components/container';
import { ButtonLink } from 'components/styles_components/link';

const Footer = () => {
  return (
    <StyledFooter>
      <Container>
        <Grid container spacing={4} >
            <Grid size={{ xs: 12, md: 4}} >
              <Box sx={{ mb: 2, pt: 2 }}>
                <Logo width="42" />
              </Box>
              <FooterText>
                <FormattedMessage id="footer.description" />
              </FooterText>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 2 }}>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <FooterTitle>
                <FormattedMessage id="footer.documents" />
              </FooterTitle>
              <Stack spacing={0.5}>
                <ButtonLink to={TermsLink()}>
                  <FormattedMessage id="footer.link.terms" />
                </ButtonLink>
                <ButtonLink to={PaymentTermsLink()}>
                  <FormattedMessage id="footer.link.payment_terms" />
                </ButtonLink>
                <ButtonLink to={PrivacyPolicyLink()}>
                  <FormattedMessage id="footer.link.privacy" />
                </ButtonLink>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <FooterTitle>
                <FormattedMessage id="footer.contact" />
              </FooterTitle>
              <Stack spacing={1}>
                <FooterText><FormattedMessage id="footer.email" /></FooterText>
                <FooterText><FormattedMessage id="footer.phone" /></FooterText>
              </Stack>
            </Grid>
          </Grid>
          <DividerContainer />
          <FooterDescription>
            <FormattedMessage id="footer.copyright" />
          </FooterDescription>
      </Container>
    </StyledFooter>
  );
};

export default Footer;
